<template>
  <el-form-item :label="label" :prop="field" :rules="rules" size="small">
    <div class="app-type-map">
      <sme-baidu-map
        type='pick-point'
        :point="point"
        :is-locate="isLocate"
        app-key="itq41hB0USBoLG6Gai6hKE35yYCVAPiL"
        @select-point="handleSelect"
      ></sme-baidu-map>
    </div>
  </el-form-item>
</template>

<script>
import SmeBaiduMap from '@/components/SmeBaiduMap'

export default {
  name: 'app-type-textarea',
  components: {
    SmeBaiduMap
  },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    field: {
      type: String
    },
    rules: {
      type: [ Object, Array ]
    },
    value: {
      type: Object
    },
    rows: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: String,
      default: '请在此输入内容'
    }
  },

  data () {
    return {
      isLocate: true,
      point: undefined
    }
  },

  created () {
    this.initPoint()
  },

  methods: {
    initPoint () {
      const point = this.value

      if (point) { // 已经选了位置，不再开启定位
        this.point = point
        this.isLocate = false
      } else {
        this.point = undefined
      }
    },

    handleSelect (point) {
      this.$emit('input', point)
    }
  }
}
</script>

<style>
.app-type-map {
  width: 100%;
  height: 430px;
}
</style>
